const chartjs = require('../../../../../../components/chart/chartjs')
const { changeSVG } = require('../../../../../../js-handler/graphic')
let barSimpleChart = null;

export function createChart(parameter) {
	const canvas = document.getElementById('chartBarPayable');
	const datetimeSpan = document.getElementById('datetimeSpanPayable');
	const companyName = document.getElementById('companyNamePayable');

	companyName.textContent = parameter[0].company_name;
	datetimeSpan.textContent = parameter[0].current_dateTime;
	
	// Destruye el gráfico anterior si existe
	if (barSimpleChart) {
		barSimpleChart.destroy();
		barSimpleChart = null;
	}

	// Inicializar totales
	let current = 0;
	let total_30 = 0;
	let total_31_60 = 0;
	let total_61_90 = 0;
	let total_over_90 = 0;
	let total = 0;

	// Sumar todos los valores del parámetro
	parameter.forEach(element => {
		current += parseFloat((element.current || '0').replace(/[^0-9.-]+/g, ""));
		total_30 += parseFloat((element.total_due_30_days || '0').replace(/[^0-9.-]+/g, ""));
		total_31_60 += parseFloat((element.total_due_31_to_60_days || '0').replace(/[^0-9.-]+/g, ""));
		total_61_90 += parseFloat((element.total_due_61_to_90_days || '0').replace(/[^0-9.-]+/g, ""));
		total_over_90 += parseFloat((element.total_due_over_90_days || '0').replace(/[^0-9.-]+/g, ""));
	});

	total = parseFloat(current + total_30 + total_31_60 + total_61_90 + total_over_90)

	// Prepara los datos para el gráfico
	const chartData = {
		labels: ['Current', '0-30 days', '31-60 days', '61-90 days', 'over 90 days', 'Total Payable'],
		dataset: [
			{
				label: 'Accounts Payable',
				backgroundColor: ['#36A2EB', '#4bc0c0', '#ffcd56', '#f86624', '#ff2857', '#f36cde'],
				data: [current, total_30, total_31_60, total_61_90, total_over_90, total],
			}
		]
	};


	//Crear gráfico solo una vez con los totales
	barSimpleChart = chartjs.start({
		elem: 'bar',
		act: 'createMultipleLineWithLabels',
		targetChart: { html: canvas },
		data: chartData,
		options: {
			aspectRatio: 10 / 5,
			legend: false
		}
	});

	if (!canvas) {
		console.log('Canvas chartBarReceivable no encontrado');
		return;
	}

}